import { Component, OnInit,Renderer2 } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {

  public mostrarChatBot: boolean;
  public chatbotId:any;
  public chatbotVersion:any;


  constructor(private renderer: Renderer2) 
  { 
    this.mostrarChatBot = environment.chatBot;
    this.chatbotId = environment.chatBotId;
    this.chatbotVersion = environment.chatBotVersion;
  }

  ngOnChanges() {
    this.mostrarBot();
}

  ngOnInit(): void {
    this.mostrarBot();
  }


  mostrarBot() {
    if (this.mostrarChatBot) {

      const userString = localStorage.getItem('Usuario');
      const user = userString ? JSON.parse(userString) : null;

      if (!user) return;

      const script = this.renderer.createElement('script');

      const scriptContent = `
        var Params = {
          BotId: ${this.chatbotId},
          BotVersionId: ${this.chatbotVersion},
          BotHost: 'https://botai.smartdataautomation.com',
          Initial_Step: '/reset',
          user_vars: { id_agent: ${user.id}, role_id: ${user.role_id}, name: "${user.firstname} ${user.lastname}" }
        };

        var ChatBotItem = new ChatBot(Params);
      `;

      this.renderer.setAttribute(script, 'type', 'text/javascript');
      script.appendChild(this.renderer.createText(scriptContent));
      this.renderer.appendChild(document.body, script);
    }
  }
} 



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/chatbot/chatbot.component.ts